// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const tipoClientesB2bFullfilledReducer = makeSetReducer(['tipo_clientes_b2b/fullfilled']);
